import fetch from "lib/fetch";
import type { ForeignLanguagesInterface } from "types/reference";

type ForeignLanguagesListResponse = { data: Array<ForeignLanguagesInterface> };

export const getForeignLanguagesRequest = (languageCode: string) =>
    fetch.get<ForeignLanguagesListResponse>(`reference/foreign_languages/${languageCode}`);
